import { Navigate, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ADMIN_BASE } from "@/lib/brand";
import { LayoutDashboard, Package, FileText, Mic, Calendar, Image, Mail, Megaphone, Settings, Menu, LogOut, ListTree, MessageSquareCode, Wrench, ShoppingCart, Quote, Users } from "lucide-react";

export default function AdminLayout() {
  const { admin, loading, logout } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#1A1A1A] text-white">Loading...</div>;
  }
  if (!admin) return <Navigate to={`${ADMIN_BASE}/login`} replace />;

  const links = [
    { to: ADMIN_BASE, label: "Dashboard", icon: LayoutDashboard, end: true },
    { to: `${ADMIN_BASE}/products`, label: "Products", icon: Package },
    { to: `${ADMIN_BASE}/spares`, label: "Spares", icon: Wrench },
    { to: `${ADMIN_BASE}/spare-orders`, label: "Spare Orders", icon: ShoppingCart },
    { to: `${ADMIN_BASE}/blogs`, label: "Blogs", icon: FileText },
    { to: `${ADMIN_BASE}/podcasts`, label: "Podcasts", icon: Mic },
    { to: `${ADMIN_BASE}/events`, label: "Events", icon: Calendar },
    { to: `${ADMIN_BASE}/gallery`, label: "Gallery", icon: Image },
    { to: `${ADMIN_BASE}/leads`, label: "Leads", icon: Mail },
    { to: `${ADMIN_BASE}/testimonials`, label: "Testimonials", icon: Quote },
    { to: `${ADMIN_BASE}/team`, label: "Team", icon: Users },
    { to: `${ADMIN_BASE}/announcements`, label: "Announcements", icon: Megaphone },
    { to: `${ADMIN_BASE}/menu`, label: "Navigation", icon: ListTree },
    { to: `${ADMIN_BASE}/chat-widget`, label: "Chat Widget", icon: MessageSquareCode },
    { to: `${ADMIN_BASE}/settings`, label: "Settings", icon: Settings },
  ];

  return (
    <div className="min-h-screen bg-gray-50 flex">
      <aside className="w-64 bg-[#0F0F0F] text-white flex flex-col sticky top-0 h-screen" data-testid="admin-sidebar">
        <div className="px-5 py-6 border-b border-white/10">
          <div className="font-heading font-black text-white text-xl uppercase tracking-tight">Tara Admin</div>
          <div className="text-[10px] text-[#FFCC00] uppercase tracking-[0.3em] mt-1">Control Room</div>
        </div>
        <nav className="flex-1 py-4 overflow-y-auto">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.end}
              className={({ isActive }) => `admin-link ${isActive ? "active" : ""}`}
              data-testid={`admin-link-${l.label.toLowerCase()}`}
            >
              <l.icon className="w-4 h-4" />
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-white/10">
          <div className="text-xs text-gray-400 mb-2">{admin.email}</div>
          <button
            onClick={() => { logout(); navigate(`${ADMIN_BASE}/login`); }}
            className="w-full flex items-center gap-2 px-3 py-2 text-sm text-gray-300 hover:bg-[#E65C00] hover:text-white transition-colors"
            data-testid="admin-logout"
          >
            <LogOut className="w-4 h-4" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 p-8" data-testid="admin-main">
        <Outlet />
      </main>
    </div>
  );
}
